import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useMarketingObjectiveDependencies } from './useMarketingObjectiveDependencies';

export const useMarketingObjectiveFormFieldValue = () => {
    const dependencies = useMarketingObjectiveDependencies();

    return useFormFieldValue({ field: 'marketingObjective' }, dependencies);
};
